var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9E7EC"
    },
    points: "392.001,150 392.001,512 0.001,512 0.001,0 242.001,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C5D3DD"
    },
    points: "392.001,150 392.001,512 197.001,512 197.001,0 242.001,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73BCFF"
    },
    points: "263.212,0 242.001,0 242.001,150 392.001,150 392.001,128.789 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9F00"
    },
    points: "511.999,460 501.5,470.501 491.001,481 400.101,390.099 410.601,379.6 421.1,369.099 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 181,
    style: {
      fill: "#6E6E6E"
    },
    width: 212,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 241,
    style: {
      fill: "#6E6E6E"
    },
    width: 152,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 361,
    style: {
      fill: "#6E6E6E"
    },
    width: 152,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 301,
    style: {
      fill: "#6E6E6E"
    },
    width: 152,
    height: 30
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 241,
    style: {
      fill: "#5A5A5A"
    },
    width: 15,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 301,
    style: {
      fill: "#5A5A5A"
    },
    width: 15,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 361,
    style: {
      fill: "#5A5A5A"
    },
    width: 15,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 181,
    style: {
      fill: "#5A5A5A"
    },
    width: 75,
    height: 30
  })), /*#__PURE__*/React.createElement("rect", {
    x: 443.371,
    y: 366.024,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1073.822 415.8045)",
    style: {
      fill: "#FF7816"
    },
    width: 14.848,
    height: 128.549
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E6E6E"
    },
    d: "M421.1,241.899c-39.598-39.899-108.6-39.899-148.198,0c-41.102,40.801-41.102,107.401,0,148.2 c40.8,41.1,107.399,41.1,148.198,0c20.7-20.4,30.901-47.1,30.901-74.099C452.001,288.999,441.8,262.299,421.1,241.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A5A5A"
    },
    d: "M421.1,390.099c-40.8,41.1-107.399,41.1-148.198,0c-41.102-40.8-41.102-107.399,0-148.2 L421.1,390.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ED0FF"
    },
    d: "M400.101,262.899C385.401,248.199,366.201,241,347,241s-38.401,7.2-53.101,21.899 c-29.099,29.399-29.399,76.8,0,106.199c28.5,28.2,77.701,28.2,106.201,0C429.2,339.699,429.501,292.299,400.101,262.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73BCFF"
    },
    d: "M400.101,369.099c-28.5,28.2-77.701,28.2-106.201,0c-29.399-29.399-29.099-76.8,0-106.199 L400.101,369.099z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewSample);
export default __webpack_public_path__ + "static/media/previewSample.9e5708c2da302ceef87f08ab1192f4a3.svg";
export { ForwardRef as ReactComponent };